import {
  GET_PAYMENT_METHODS_REQUEST,
  GET_PAYMENT_METHODS_SUCCESS,
  GET_PAYMENT_METHODS_FAILURE,
  SHOW_PAYMENT_METHOD_FORM,
  HIDE_PAYMENT_METHOD_FORM,
  CREATE_PAYMENT_METHOD_REQUEST,
  CREATE_PAYMENT_METHOD_SUCCESS,
  CREATE_PAYMENT_METHOD_FAILURE,
  SET_DEFAULT_PAYMENT_METHOD_REQUEST,
  SET_DEFAULT_PAYMENT_METHOD_SUCCESS,
  SET_DEFAULT_PAYMENT_METHOD_FAILURE,
  SHOW_CONFIRM_DELETE_PAYMENT_METHOD,
  HIDE_CONFIRM_DELETE_PAYMENT_METHOD,
  DELETE_PAYMENT_METHOD_REQUEST,
  DELETE_PAYMENT_METHOD_SUCCESS,
  DELETE_PAYMENT_METHOD_FAILURE,
  CHANGE_GUEST_PAYMENT_METHOD,
  UPDATE_GUEST_CREDIT_CARD_DETAILS,
  RESET_GUEST_CREDIT_CARD_DETAILS,
  UPDATE_GUEST_GIFT_CARD_DETAILS,
  RESET_GUEST_GIFT_CARD_DETAILS,
  SET_TOUCHED_CREDIT_CARD_DETAILS,
  SHOW_SELECT_PAYMENT_METHOD_FORM,
  SET_SELECTED_PAYMENT_METHOD,
  SHOW_PAYMENT_METHOD_SELECTION_FORM,
} from './paymentMethodsTypes';
import api from '../../api';
import { createAlert } from '../Alert/alertActions';
import isValidCreditCard from '../../utils/isValidCreditCard';
import { shouldValidatePostalCode, shouldValidateAddress } from './utils';
import {
  displayTransferBalanceModal,
  getLoyalty,
} from '../Loyalty/loyaltyActions';

export function getPaymentMethods() {
  return function(dispatch) {
    dispatch({ type: GET_PAYMENT_METHODS_REQUEST });
    return api.get(`/payment-methods`).then(
      (response) => {
        dispatch({
          type: GET_PAYMENT_METHODS_SUCCESS,
          response: response.data,
        });
      },
      (error) => {
        dispatch({ type: GET_PAYMENT_METHODS_FAILURE, error });
      }
    );
  };
}

export function showPaymentMethodForm(noDialogBackground) {
  return function(dispatch, getState) {
    const paymentMethods = getState().paymentMethodsReducer.paymentMethods;
    dispatch({
      type: SHOW_PAYMENT_METHOD_FORM,
      noDialogBackground: noDialogBackground && paymentMethods.length,
    });
  };
}

export function showSelectPaymentMethodForm(bool) {
  return function(dispatch) {
    dispatch({
      type: SHOW_SELECT_PAYMENT_METHOD_FORM,
      selectPaymentMethodFormIsVisible: bool,
    });
  };
}

export function setSelectedPaymentMethod(selectedPaymentMethod) {
  return function(dispatch) {
    dispatch({
      type: SET_SELECTED_PAYMENT_METHOD,
      selectedPaymentMethod: selectedPaymentMethod,
    });
  };
}

export function showPaymentMethodSelectionForm(bool) {
  return function(dispatch) {
    dispatch({
      type: SHOW_PAYMENT_METHOD_SELECTION_FORM,
      paymentMethodSelectionFormIsVisible: bool,
    });
  };
}

export function clearErrorMessage() {
  return {
    type: CREATE_PAYMENT_METHOD_FAILURE,
    errorMessage: {},
  };
}
export function hidePaymentMethodForm() {
  return {
    type: HIDE_PAYMENT_METHOD_FORM,
  };
}

export function createPaymentMethod({
  card_number,
  cardholder_name,
  cvv,
  expiry_month,
  expiry_year,
  postal_code,
  street_number,
  street_name,
}) {
  let formBody = {
    type: 'credit_card',
    details: {
      card_number,
      cardholder_name,
      cvv,
      expiry_date: `${expiry_year}-${expiry_month}-01`,
    },
  };
  if (shouldValidatePostalCode) {
    formBody = { ...formBody, details: { ...formBody.details, postal_code } };
  }
  if (shouldValidateAddress) {
    formBody = {
      ...formBody,
      details: { ...formBody.details, street_number, street_name },
    };
  }
  return function(dispatch) {
    dispatch({
      type: CREATE_PAYMENT_METHOD_FAILURE,
      errorMessage: {},
    });
    if (expiry_month > 12) {
      return dispatch({
        type: CREATE_PAYMENT_METHOD_FAILURE,
        errorMessage: { message: 'Invalid Expiry Date' },
      });
    }
    if (expiry_year.length < 4) {
      return dispatch({
        type: CREATE_PAYMENT_METHOD_FAILURE,
        errorMessage: { message: 'Invalid Expiry Year' },
      });
    }
    if (!isValidCreditCard(expiry_month, expiry_year)) {
      return dispatch({
        type: CREATE_PAYMENT_METHOD_FAILURE,
        errorMessage: { message: 'Expired Credit Card' },
      });
    }

    dispatch({ type: CREATE_PAYMENT_METHOD_REQUEST });
    return api
      .post(`/payment-methods`, formBody, { ignore_interception: true })
      .then((response) => {
        dispatch({
          type: CREATE_PAYMENT_METHOD_SUCCESS,
          response: response.data,
        });
        dispatch({
          type: CREATE_PAYMENT_METHOD_FAILURE,
          errorMessage: {},
        });
        dispatch(getPaymentMethods());
      })
      .catch((error) => {
        dispatch({
          type: CREATE_PAYMENT_METHOD_FAILURE,
          errorMessage: error.response.data.errors,
        });
      });
  };
}

export function requestDigitalCard(card_number, pin) {
  return function(dispatch) {
    dispatch({ type: CREATE_PAYMENT_METHOD_REQUEST });
    const payload = {
      type: 'gift_card',
      details: {
        card_number,
        pin,
      },
    };
    return api
      .post(`/payment-methods`, payload, { ignore_interception: true })
      .then(() => {
        dispatch(displayTransferBalanceModal(false));
        dispatch(getPaymentMethods());
        dispatch(getLoyalty());
      })
      .catch((error) => {
        dispatch(
          createAlert({
            type: 'error',
            message:
              error?.response?.data?.errors?.message ||
              'Something went wrong. Please try again later.',
          })
        );
      });
  };
}

export function setDefaultPaymentMethod(cardId) {
  return function(dispatch) {
    dispatch({ type: SET_DEFAULT_PAYMENT_METHOD_REQUEST });
    return api.post(`/payment-methods/${cardId}/default`).then(
      (response) => {
        dispatch({
          type: SET_DEFAULT_PAYMENT_METHOD_SUCCESS,
          cardId,
        });
      },
      (error) => {
        dispatch({ type: SET_DEFAULT_PAYMENT_METHOD_FAILURE, error });
      }
    );
  };
}

export function showConfirmDeletePaymentMethod() {
  return {
    type: SHOW_CONFIRM_DELETE_PAYMENT_METHOD,
  };
}

export function hideConfirmDeletePaymentMethod() {
  return {
    type: HIDE_CONFIRM_DELETE_PAYMENT_METHOD,
  };
}

export function deletePaymentMethod(cardId) {
  return function(dispatch) {
    dispatch({ type: DELETE_PAYMENT_METHOD_REQUEST });
    return api.delete(`/payment-methods/${cardId}`).then(
      (response) => {
        dispatch(getPaymentMethods());
        dispatch({
          type: DELETE_PAYMENT_METHOD_SUCCESS,
          response: response.data,
        });
      },
      (error) => {
        dispatch({ type: DELETE_PAYMENT_METHOD_FAILURE, error });
      }
    );
  };
}

export function changeGuestPaymentMethod(method) {
  return function(dispatch) {
    dispatch({ type: CHANGE_GUEST_PAYMENT_METHOD, method });
  };
}

export function updateGuestPaymentDetails(guestCreditCardDetails) {
  return function(dispatch) {
    dispatch({
      type: UPDATE_GUEST_CREDIT_CARD_DETAILS,
      guestCreditCardDetails,
    });
  };
}

export function resetGuestCreditCardDetails() {
  return function(dispatch) {
    dispatch({ type: RESET_GUEST_CREDIT_CARD_DETAILS });
  };
}

export function updateGuestGiftCardDetails(guestGiftCardDetails) {
  return function(dispatch) {
    dispatch({
      type: UPDATE_GUEST_GIFT_CARD_DETAILS,
      guestGiftCardDetails,
    });
  };
}

export function resetGuestGiftCardDetails() {
  return function(dispatch) {
    dispatch({ type: RESET_GUEST_GIFT_CARD_DETAILS });
  };
}

export function setTouchedCreditCardDetails(bool) {
  return function(dispatch) {
    dispatch({ type: SET_TOUCHED_CREDIT_CARD_DETAILS, bool });
  };
}
